import apiClient from './apiClient'

export const uploadLogService = {
  getById: async (id) => {
    const response = await apiClient.get(`/admin/upload-logs/${id}`)
    return response.data
  },

  exportErrorsCsv: async (id) => {
    return apiClient.get(`/admin/upload-logs/${id}/errors/export`, {
      responseType: 'blob',
    })
  },

  downloadErrorsCsvBlob: async (id, fallbackFileName = 'upload-errors.csv') => {
    const response = await uploadLogService.exportErrorsCsv(id)
    const disposition = response.headers?.['content-disposition']
    let fileName = fallbackFileName
    if (disposition) {
      const match = /filename="([^"]+)"/i.exec(disposition)
      if (match?.[1]) fileName = match[1]
    }
    const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = fileName
    document.body.appendChild(a)
    a.click()
    a.remove()
    window.URL.revokeObjectURL(url)
  },
}
